import { TextCell } from '@common/components/TextCell';

interface BuyerCellProps {
	/** The buyer's full name */
	buyerName: string;
}

export const BuyerCell = ({ buyerName }: BuyerCellProps) => {
	return <TextCell value={buyerName} weight='semibold' />;
};
